import { UAEntityTypes } from '@unifyapps/defs/types/entities';
import type { CustomBlockVersions, InterfacePageEntity } from '@unifyapps/defs/types/page';
import type { CustomComponentSearchRequest } from '@unifyapps/network/generated/models/customComponentSearchRequest';

/**
 * Walks every page's customBlocksVersionsMap, deduplicates by entityId,
 * and returns a flat array of custom block versions.
 */
export function collectCustomBlockVersions(
  pages: (InterfacePageEntity | undefined)[],
): CustomBlockVersions[] {
  const seen = new Set<string>();
  const out: CustomBlockVersions[] = [];
  for (const page of pages) {
    const versions = Object.values(page?.properties?.customBlocksVersionsMap || {});
    for (const v of versions) {
      if (v && !seen.has(v.entityId)) {
        seen.add(v.entityId);
        out.push({ entityId: v.entityId, version: v.version });
      }
    }
  }
  return out;
}

export function getCustomBlocksEntitySnapshotsFetchRequest(
  customBlockVersionsArray: CustomBlockVersions[],
) {
  return {
    entities: [
      {
        entityType: UAEntityTypes.CustomBlock,
        entityIdVersions: customBlockVersionsArray.map(({ entityId, version }) => ({
          entityId,
          currentVersion: version,
        })),
      },
    ],
  };
}

export const getCustomBlocksQueryFilter = (
  customBlockVersionsArray: CustomBlockVersions[],
): CustomComponentSearchRequest => {
  return {
    ids: [...new Set(customBlockVersionsArray.map((b) => b.entityId))],
  };
};
